import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import VideosAdminContainer from '../containers/videosAdminContainer';
import VideosUnauthorizedContainer from '../containers/videosUnauthorizedContainer';

const VideosAdmin = () => (
  <>
    <Switch>
      <Route path="/videos/organizations/:orgId/:type/topics/:id/:tabId">
        <VideosAdminContainer isEditRoute isTopicsRoute />
      </Route>
      <Route path="/videos/organizations/:orgId/:type/topics/:id">
        <VideosAdminContainer isTopicsRoute />
      </Route>
      <Route path="/videos/organizations/:orgId/:type/:id/:tabId">
        <VideosAdminContainer isEditRoute />
      </Route>
      <Route path="/videos/organizations/:orgId/:type/unauthorized">
        <VideosUnauthorizedContainer isLearner={false} />
      </Route>
      <Route path={['/videos/organizations/:orgId/:type', '/videos']}>
        <VideosAdminContainer />
      </Route>
    </Switch>
    <ReactQueryDevtools initialIsOpen={false} />
  </>
);

export default React.memo(VideosAdmin);
